import { IonCard, IonCardHeader, IonCardTitle, IonListHeader, IonButton, IonButtons, IonContent, IonHeader, IonImg, IonItem, IonLabel, IonList, IonTitle,  IonToolbar, IonicSlides } from '@ionic/react';
import React, {  useState } from 'react';
import { IonIcon } from '@ionic/react';
import { alarmSharp, callSharp, cellularSharp, desktopSharp, linkSharp, logoFacebook, logoInstagram, logoPinterest, logoSnapchat, logoTiktok, logoTwitter, logoWhatsapp, logoYoutube, mailSharp, mapSharp, medalSharp,} from 'ionicons/icons';
import { CreadoMexicoProps, TurComProps } from '../interfaces';

// import required modules

import closePage from '../assets/close-circle.svg'
import location_white from '../assets/location-pin.svg'


//Estilos de cada carta
import './SabYucatanModal.css'

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css/controller'
import { Autoplay, Keyboard, Pagination, Scrollbar, Zoom } from 'swiper';

import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/keyboard';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/zoom';
import '@ionic/react/css/ionic-swiper.css';


const LegadoMexicoModal = ({
    marker,
    onDismiss,
  }: {
    marker : CreadoMexicoProps;
    onDismiss: () => void;
  }) => {
  
    return (
        <>
        <IonHeader className='art-ion-header'>
            <IonToolbar className='name-header-modal1 toolbar-modal-tour'>
                <IonButtons className='button-close'>
                    <IonButton className='text-close-tour' onClick={() => onDismiss()}>
                        <img src={closePage} alt="imageClose" id='icon-close' />
                    </IonButton>
                </IonButtons>
                <IonImg className='header-modal-img-tour'
                    src={marker.imagenes[0]}
                    alt={marker.nombre}
                >                    
                </IonImg>
                <IonTitle>
                    <div className="open">
                            {marker.nombre}<br/>
                    </div>
                </IonTitle>
            </IonToolbar>
        </IonHeader>
        
        <IonContent fullscreen={true} className="ion-padding">
        
            <div className="open">
                <h5>{marker.nombre}</h5>
                {marker.municipio}, {marker.estado}
            </div>
            <IonList>
                <IonItem>
                <p>{marker.descripcion}</p>
                </IonItem>
            </IonList>
            <Swiper
                // spaceBetween={5}
                modules={[Autoplay, Keyboard, Pagination, Scrollbar, Zoom, IonicSlides]}
                autoplay={true}
                keyboard={true}
                pagination={{
                  dynamicBullets: true,
                }}
                scrollbar={true}
                zoom={true}
                slidesPerView={1}
                onSlideChange={() => console.log('slide change')}
                onSwiper={(swiper) => console.log(swiper)}
              >
              {marker.imagenes.map((element, index) => 
            <>
              <SwiperSlide>
                <IonCard id='swiper-ioncard'>
                <img className="img-swiper" alt='Hola' src={element} />
                  <IonCardHeader>
                    <IonCardTitle>{marker.nombre}</IonCardTitle>
                  </IonCardHeader>
                </IonCard>
              </SwiperSlide>
                </>
              )
              }
              </Swiper>

        </IonContent>
        </>
    );
};

export default LegadoMexicoModal;